export default [
  {
    path: '/records/quote',
    name: 'recordsQuote',
    component: () => import('@/views/records/quote'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
  {
    path: '/records/quote/detail',
    name: 'recordsQuoteDetail',
    component: () => import('@/views/records/quote/detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/policy',
    name: 'recordsPolicy',
    component: () => import('@/views/records/policy'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
  {
    path: '/records/policy/detail',
    name: 'recordsPolicyDetail',
    component: () => import('@/views/records/policy/detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/policy/manual/detail',
    name: 'recordsPolicyManualDetail',
    component: () => import('@/views/records/policy/manual-detail'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/referral',
    name: 'recordsRefer',
    component: () => import('@/views/records/referral'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
  {
    path: '/records/referrer',
    name: 'referrerReward',
    component: () => import('@/views/records/referrerReward'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/quote/plan',
    name: 'planInfo',
    component: () => import('@/views/records/quote/plan-info'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/records/micropolicy',
    name: 'recordsMicropolicy',
    component: () => import('@/views/records/micropolicyList'),
    meta: {
      keepAlive: false,
      bg_white: true
    },
  },
  {
    path: '/records/micropolicy/detail',
    name: 'recordsMicropolicyDetail',
    component: () => import('@/views/records/micropolicy/detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/campaigns',
    name: 'recordsMicropolicy',
    component: () => import('@/views/records/micropolicy'),
    meta: {
      keepAlive: false,
      bg_white: true
    },
    children:[
      {
        path: '',
        component: () => import('@/views/records/micropolicy/components/purchase-list'),
        name: 'purchases'
      },
      {
        path: 'pv-renew-promo',
        component: () => import('@/views/records/micropolicy/components/pvRenewPromo/list'),
        name: 'pv-renew-promo'
      },
      {
        path: 'flight-delay',
        component: () => import('@/views/records/micropolicy/components/flightDelay/index'),
        name: 'flight-delay'
      },
      {
        path: 'purchases',
        component: () => import('@/views/records/micropolicy/components/purchase-list'),
        name: 'purchases'
      },
      {
        path: 'HD-redeem',
        component: () => import('@/views/records/micropolicy/components/hd-list'),
        name: 'HD-redeem'
      },
      {
        path: 'gift-pack',
        component: () => import('@/views/records/micropolicy/components/gift-pack-list'),
        name: 'gift-pack'
      },
      {
        path: 'travel',
        component: () => import('@/views/records/micropolicy/components/annual-travel/list'),
        name: 'travel'
      },
      {
        path: 'free-round-trip',
        component: () => import('@/views/records/micropolicy/components/free-trip/list'),
        name: 'free-round-trip'
      },
      {
        path: 'welcome-offer',
        component: () => import('@/views/records/micropolicy/components/welcome-offer/list'),
        name: 'welcome-offer'
      },
      {
        path: 'aqua-land',
        component: () => import('@/views/records/micropolicy/components/aqua-land/list'),
        name: 'aqua-land'
      },
      {
        path: 'HANBERG-card',
        component: () => import('@/views/records/micropolicy/components/exclusive-reward-list'),
        name: 'HANBERG-card'
      },
      {
        path: 'HZMB',
        component: () => import('@/views/records/micropolicy/components/promo-hzmb/promo-hzmb-list'),
        name: 'HZMB'
      },
      {
        path: 'road-bomb',
        component: () => import('@/views/records/micropolicy/components/car-bomb/list'),
        name: 'road-bomb'
      },
      {
        path: 'HANBERG-cashback',
        component: () => import('@/views/records/micropolicy/components/cashback/hangerCashbackList'),
        name: 'HANBERG-cashback'
      },
      {
        path: 'traveller-2024',
        component: () => import('@/views/records/micropolicy/components/annual-travel/traveller-2024-list'),
        name: 'traveller-2024'
      },
      {
        path: 'tourist-list',
        component: () => import('@/views/records/micropolicy/components/tourist/tourist-list'),
        name: 'tourist-list'
      },
      {
        path: 'road-bomb',
        component: () => import('@/views/records/micropolicy/components/car-bomb/list'),
        name: 'road-bomb'
      },
      {
        path: 'home-fire',
        component: () => import('@/views/records/micropolicy/components/home-fire/index'),
        name: 'home-fire'
      },
      {
        path: 'no-claim',
        component: () => import('@/views/records/micropolicy/components/claim/list'),
        name: 'no-claim'
      },
    ]
  },
  {
    path: '/records/micropolicy/purchase-detail',
    name: 'MicropolicyPurchaseDetail',
    component: () => import('@/views/records/micropolicy/purchase-detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/HDRedeem-detail',
    name: 'MicropolicyHDRedeemDetail',
    component: () => import('@/views/records/micropolicy/purchase-detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/import-tracking-number',
    name: 'importTrackingNumber',
    component: () => import('@/views/records/micropolicy/components/import-tracking'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/renewal',
    name: 'Renewal',
    component: () => import('@/views/records/renewal'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
  {
    path: '/records/micropolicy/referrer-talks-detail',
    name: 'ReferrerTalksDetail',
    component: () => import('@/views/records/micropolicy/components/referrer-talks-detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/exclusive-reward-detail/:id',
    name: 'exclusiveDetail',
    component: () => import('@/views/records/micropolicy/components/exclusiveDetail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/promo-hzmb/:id',
    name: 'promoHzmbDetail',
    component: () => import('@/views/records/micropolicy/components/promo-hzmb/promo-hzmb-detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/referrer-bonus-detail/:id',
    name: 'exclusiveDetail',
    component: () => import('@/views/records/micropolicy/components/referBonusDetail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/hk01/:id',
    name: 'hk01Detail',
    component: () => import('@/views/records/micropolicy/components/hk01/detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/incentive-bonus-detail/:id',
    name: 'exclusiveDetail',
    component: () => import('@/views/records/referrerReward/component/incentiveBonusDetail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/hanberg-cashback/:id',
    name: 'hangerCashbackDetail',
    component: () => import('@/views/records/micropolicy/components/cashback/hangerCashbackDetail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/flight-delay/:id',
    name: 'flightDelayDetail',
    component: () => import('@/views/records/micropolicy/components/flightDelay/detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/micropolicy/pv-renew-promo/:id',
    name: 'pvRenewPromoDetail',
    component: () => import('@/views/records/micropolicy/components/pvRenewPromo/detail'),
    meta: {
      keepAlive: false
    },
  },
  {
    path: '/records/extra-benefits/list',
    name: 'recordsExtraBenefitsList',
    component: () => import('@/views/records/extra-benefits-list'),
    meta: {
      keepAlive: false,
      bg_white: true
    },
  },
  {
    path: '/records/claim',
    name: 'recordsClaim',
    component: () => import('@/views/records/claim/list'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
  {
    path: '/records/tourist-team/add',
    component: () => import('@/views/records/micropolicy/components/tourist/team-form'),
    name: 'add-team-form'
  },
  {
    path: '/records/tourist-team/detail/:id',
    component: () => import('@/views/records/micropolicy/components/tourist/detail'),
    name: 'team-form-detail'
  },
  {
    path: '/records/micropolicy/car-bomb/:id',
    name: 'carBombDetail',
    component: () => import('@/views/records/micropolicy/components/car-bomb/detail'),
    meta: {
      keepAlive: false
    },
  },
]
